"use strict";

exports.__esModule = true;
var _Testimonials = _interopRequireDefault(require("./Testimonials"));
exports.default = _Testimonials.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}